<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
    <g id="Group_134" data-name="Group 134" transform="translate(-0.418)">
      <g id="Hit_Area" data-name="Hit Area">
        <circle id="Ellipse_5" data-name="Ellipse 5" cx="20" cy="20" r="20" transform="translate(0.418)" fill="aqua" opacity="0.25"/>
        <circle id="Ellipse_3" data-name="Ellipse 3" cx="16" cy="16" r="16" transform="translate(4.418 4)" fill="aqua" opacity="0.25"/>
        <circle id="Ellipse_4" data-name="Ellipse 4" cx="10" cy="10" r="10" transform="translate(10.418 10)" fill="aqua"/>
      </g>
    </g>
  </svg>
  